import type { AlertLevel } from '../types/monitoraggio';

export interface AlertThreshold {
  minPercentBelow: number;
  maxPercentBelow?: number;
}

export const ALERT_THRESHOLDS: Record<Exclude<AlertLevel, 'none'>, AlertThreshold> = {
  good: { minPercentBelow: 10, maxPercentBelow: 20 },
  rare: { minPercentBelow: 20, maxPercentBelow: 35 },
  exceptional: { minPercentBelow: 35 },
} as const;

/**
 * Determine the alert level based on the percentage drop from the average price.
 */
export function getAlertLevel(percentBelow: number): AlertLevel {
  if (percentBelow >= ALERT_THRESHOLDS.exceptional.minPercentBelow) {
    return 'exceptional';
  }
  if (percentBelow >= ALERT_THRESHOLDS.rare.minPercentBelow) {
    return 'rare';
  }
  if (percentBelow >= ALERT_THRESHOLDS.good.minPercentBelow) {
    return 'good';
  }
  return 'none';
}

/** Colors associated with each alert level (for UI consistency) */
export const ALERT_COLORS: Record<AlertLevel, string> = {
  none: '#6B7280',
  good: '#10B981',
  rare: '#F59E0B',
  exceptional: '#EF4444',
} as const;
